/**
 * Duplicate / near-duplicate blog slugs mapped to the slug that should own the
 * canonical URL. Kept in a standalone, dependency-free module so the root shell
 * can resolve canonicals without pulling the whole post dataset into the client
 * bundle.
 */
export const BLOG_CANONICAL_OVERRIDES: Record<string, string> = {
};

/** Resolves /blog/<slug> paths to their canonical equivalent. */
export function canonicalBlogPath(path: string): string {
  const match = /^\/blog\/([^/?#]+)\/?$/.exec(path);
  if (!match) return path;
  const target = BLOG_CANONICAL_OVERRIDES[match[1]];
  return target ? `/blog/${target}` : path;
}
